module.exports = {
    CREATED: 'created',
    MATCHED: 'matched'
}
